import React from 'react';
import { Order } from '@hero/schema';
import { useMapContext } from '@hero/web-context';
import { OrderInfoCard } from './OrderInfoCard';

export interface OrderInfoCardWrapperProps {
  order: Order;
  onClick: () => void;
}

/**
 * OrderInfoCardWrapper - Wraps OrderInfoCard with MapContext logic
 * Hides the card when actively editing a location or when Save/Cancel buttons are shown
 */
export const OrderInfoCardWrapper: React.FC<OrderInfoCardWrapperProps> = ({ order, onClick }) => {
  const ctx = useMapContext();

  // Hide card when:
  // 1. Actively editing a location (editingIndex !== null)
  // 2. When Save/Cancel buttons would be shown (hasUnsavedChanges && !editingIndex)
  const shouldHide = ctx.editingIndex !== null || ctx.hasUnsavedChanges;

  if (shouldHide) {
    return null;
  }

  return <OrderInfoCard order={order} onClick={onClick} />;
};
